<template>
    <b-card title="Create Campaign">
        <b-col cols="12" style="margin-bottom:15px;">
            <label>Name <span style="color:red">(*)</span></label>
            <b-form-input v-model="form.name" placeholder="Enter campaign name"></b-form-input>
        </b-col>

        <b-col cols="12" style="margin-bottom : 15px">
            <label>Status</label>
            <b-form-select
                v-model="form.status"
                placeholder="----- Select Status -----"
                :options="statusChoice">
            </b-form-select>
        </b-col>
        
        <b-col cols="12" style="margin-bottom:15px">
            <label>Message <span style="color:red">(*)</span></label>
            <b-form-textarea
                v-model="form.message"
                placeholder="Promo Message"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </b-col>

        <b-col cols="12">
            <label>Start Date <span style="color:red">(*)</span></label>
            <b-form-datepicker v-model="form.startDate" class="mb-2"></b-form-datepicker>
        </b-col>

        <b-col cols="12">
            <label>End Date <span style="color:red">(*)</span></label>
            <b-form-datepicker v-model="form.endDate" class="mb-2"></b-form-datepicker>
        </b-col>

        <b-col cols="12" style="margin-bottom : 15px">
            <label>Extends Month <span style="color:red">(*)</span></label>
            <b-form-input v-model="form.extendsMonth" placeholder="Extends Month"></b-form-input>
        </b-col>
        
        <b-col cols="12" class="mb-1">
            <label>PCode <span style="color:red">(*)</span></label>
            <b-form-select
                v-model="selectedPCode"
                placeholder="----- Select PCode To Add -----"
                :options="listPCodes"
                show-empty>
            </b-form-select>
            <b-button class="mt-1" variant="outline-success" @click="doAddPCode">Add PCode</b-button>
        </b-col>

        <b-col cols="12" class="mb-1">
            <b-table
                :items="form.pCodes"
                :fields="pCodeFields"
                show-empty
            >

            <template #cell(actions)="row">
                <b-button variant="danger" @click="deletePCodeFromList(row.index)">
                    <feather-icon icon="Trash2Icon"/>
                </b-button>
            </template>

            </b-table>
        </b-col>

        <b-col cols="12">
            <b-button variant="success" @click="doSaveCampaign">Save</b-button>
        </b-col>
    </b-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { sleep } from '@/utils/utils.js'

export default {
    data() {
        return {
            form: {
                name: '',
                status: 'Inactive',
                message: '',
                startDate: null,
                endDate: null,
                extendsMonth: 0,
                pCodes: [],
            },
            statusChoice: [
                { value: 'Active', text: 'Active' },
                { value: 'Inactive', text: 'Inactive' },
            ],
            pCodeFields: [
                { key: 'name', label: 'PCode' },
                { key: 'actions', label: 'Action' }
            ],
            selectedPCode: null,
            pcodes: [],
        }
    },
    mounted() {
        this.getAllPCodes();
    },
    methods: {
        ...mapActions({
            'getAllPCodes': 'pcode/getAllPCodes',
            'createCampaign': 'campaign/createCampaign',
        }),
        doAddPCode() {
            
            let foundIndex = this.form.pCodes.findIndex((pcode) => (pcode.name === this.selectedPCode.name));
            
            if (foundIndex < 0) {
                let tempData = this.form.pCodes;
                tempData.push({ id: this.selectedPCode._id, name: this.selectedPCode.name });
                this.form.pCodes = tempData;
            }
        },
        deletePCodeFromList(indexStart) {
            this.form.pCodes.splice(indexStart, 1)
        },
        doSaveCampaign() {
            let deepCopy = JSON.parse(JSON.stringify(this.form));

            if (deepCopy.pCodes.length === 0) {
                this.$bvToast.toast(`List PCodes Is Empty`, {
                    title: "Failed",
                    variant: "danger",
                    solid: true,
                });

                // Prevent Any Saving Data From Run
                return;
            }

            this.createCampaign(deepCopy).then(async (response) => {
                this.$bvToast.toast(`You have successfully created a Campaign ${this.form.name}`, {
                    title: "Success",
                    variant: "success",
                    solid: true,
                });
                await sleep(1000)
                this.$router.push({ name: "campaign" });
            }).catch((e) => {
                this.$bvToast.toast(`Failed to create (${this.form.name})`, {
                    title: "Fail",
                    variant: "danger",
                    solid: true,
                });
            })
        }
    },
    computed: {
        ...mapState({
            listPCodes: (state) => {
                return state.pcode.pcodes.map((pcode) => {
                    return { value: pcode, text: pcode.name };
                });
            },
        })
    }
}
</script>
